module.exports = __webpack_public_path__ + "static/media/01.National Award -Kogga kamath.ffbea89d.JPG";